'use client';

import React from 'react';
import FAQSection from '@/components/organisms/faq-section';
import { TasticComponentProps } from '../types';
import { Props } from './types';

const FAQSectionTastic = ({ data }: TasticComponentProps<Props>) => {
  return (
    <>
      <FAQSection data={data?.data?.dataSource} />
    </>
  )
};

export default FAQSectionTastic;
